import { StoreService } from 'projects/dop-core/src/lib/store/ngrx-store.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { StoreKey } from 'src/app/core/store/ngrx-store.keys';
import { UserType } from 'src/app/shared/enums/user-type.enum';
import { Account } from 'src/app/shared/models/account';
import { UserDetails } from 'src/app/shared/models/user-details.model';
import {
  Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output,
  SimpleChange, SimpleChanges, ViewChild
} from '@angular/core';
import { OrderSetupService } from '../order-setup.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit, OnChanges {

  @Input() options: Account[];
  @Input() selectedValue: Account;
  @Output() selection = new EventEmitter();
  @ViewChild('globalSearch') globalSearch: any;

  optionsCopy: Account[] = [];
  searchText: string;
  isInternalUser: boolean;
  searchTextUpdate = new Subject<string>();
  previousSelected: Account;
  pageNo = 1;
  pageSize = 10;
  totalRecords: number;
  scrollElementRef: any;
  isAccountsAvailable = true;
  loading : boolean = false;

  constructor(
    private orderSetupService: OrderSetupService,
    private storeService: StoreService,
    private elementRef: ElementRef) {
  }

  async ngOnInit() {
    setTimeout(() => {
      this.scrollElementRef = this.elementRef.nativeElement.parentElement;
      this.globalSearch.nativeElement.focus();
    });
    this.previousSelected = this.selectedValue;
    const userDetails = await this.storeService.Get<UserDetails>(StoreKey[StoreKey.UserDetails]).toPromise();
    this.isInternalUser = userDetails.profile.userType.toString().toLowerCase() !== UserType[0].toString().toLowerCase();
    this.searchText = this.selectedValue.searchText;
    this.searchTextUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.pageNo = 1;
        this.filterAccounts(value);
      });
  }

  onAccountSelection(event: any) {
    event.option.searchText = this.searchText;
    this.selection.emit(event.option);
  }

  resetSearchText() {
    this.searchText = '';
    this.resetAccountsOnClearingFilter();
    this.isAccountsAvailable = true;
    this.loading = false;
  }

  async filterAccounts(value: string) {
    if (value && value.length >= 3) {
      this.loading = true;
      this.isAccountsAvailable = true;
      if (this.isInternalUser) {
        await this.filterInternalUserAccounts(value);
      } else {
        this.filterCustomerUserAccounts(value);
      }
      this.isAccountsAvailable = this.options && this.options.length > 0;
    } else {
      this.resetAccountsOnClearingFilter();
      this.isAccountsAvailable = true;
    }
    this.loading = false;
  }

  async filterInternalUserAccounts(value: any) {
    if (this.canPaginate()) {
      this.totalRecords = await this.orderSetupService.loadAccounts(value, this.pageNo, this.pageSize);
    }
    this.options = this.orderSetupService.getContext().masterData.accounts;
  }

  filterCustomerUserAccounts(value: any) {
    this.options = [...new Set(
      this.optionsCopy.filter((option) => option.code.toLowerCase().includes(value.toLowerCase())).concat(
        this.optionsCopy.filter((option) => option.name.toLowerCase().includes(value.toLowerCase())),
        this.optionsCopy.filter((option) => option.address.city.toLowerCase().includes(value.toLowerCase()))
      ))];
  }

  resetAccountsOnClearingFilter() {
    if (this.isInternalUser) {
      this.options.length = 0;
    } else {
      this.options = JSON.parse(JSON.stringify(this.optionsCopy));
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const options: SimpleChange = changes.options;
    if (this.optionsCopy.length === 0) {
      this.optionsCopy = options.currentValue;
    }
  }

  onScroll(event: any) {
    this.pageNo += 1;
    this.filterAccounts(this.searchText);
  }

  canPaginate(): boolean {
    return (this.totalRecords) ? this.pageNo <= Math.ceil(this.totalRecords / this.pageSize) : true;
  }
}
